import "../css/imagegallery.css";
import { useState, useEffect, useRef, useCallback } from "react";

function ImageGallery({ gallery = [], id }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollRef = useRef(null);
  const intervalRef = useRef(null);

  const scrollToIndex = useCallback((index) => {
    const container = scrollRef.current;
    if (!container) return;

    const width = container.clientWidth;

    container.scrollTo({
      left: index * width,
      behavior: "smooth",
    });

    setCurrentIndex(index);
  }, []);

  // Autoplay limpio (sin recrear interval cada vez)
  useEffect(() => {
    if (!gallery.length) return;

    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => {
        const next = (prev + 1) % gallery.length;
        scrollToIndex(next);
        return next;
      });
    }, 4000);

    return () => clearInterval(intervalRef.current);
  }, [gallery.length, scrollToIndex]);

  // Pausar autoplay al hacer hover
  const pauseAutoplay = () => clearInterval(intervalRef.current);
  const resumeAutoplay = () => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => {
        const next = (prev + 1) % gallery.length;
        scrollToIndex(next);
        return next;
      });
    }, 4000);
  };

  if (!gallery.length) return null;

  return (
    <div 
      className="gallery-main-container"
      onMouseEnter={pauseAutoplay}
      onMouseLeave={resumeAutoplay}
    >
      <div className="wrapper-gallery">
        <div
          ref={scrollRef}
          className="gallery-container"
          id={`wrappergallery-${id}`}
        >
          {gallery.map((url, index) => (
            <div className="item-gallery-image" key={index}>
              <img src={url} alt={`Imagen ${index + 1}`} loading="lazy" />
            </div>
          ))}
        </div>
      </div>

      <div className="gallery-indicators">
        {gallery.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentIndex ? "active" : ""}`}
            onClick={() => scrollToIndex(index)}
            aria-label={`Ir a imagen ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default ImageGallery;